import { api } from "../redux/api";

/**
 * @param {string} filePath account/wfGroup/... path from revision API or UI
 * @returns {'saveInboundTemplate'|'saveOutboundTemplate'|'saveWorkflowTemplate'}
 */
export function getPersistEndpointKeyForPath(filePath) {
  if (filePath && filePath.includes("inbound_templates/")) {
    return "saveInboundTemplate";
  }
  if (filePath && filePath.includes("outbound_templates/")) {
    return "saveOutboundTemplate";
  }
  return "saveWorkflowTemplate";
}

/**
 * @param {object} templateRecord Gson Template: { path, data, revisionId, ... }
 * @returns {object|null} POST body for save_* (parsed JSON root with TEMPLATE or WORKFLOW_DEFINITION)
 */
export function getRevisionTemplateBodyForSave(templateRecord) {
  if (!templateRecord || templateRecord.data == null) {
    return null;
  }
  const d = templateRecord.data;
  if (typeof d === "string") {
    const trimmed = d.trim();
    if (!trimmed) {
      return null;
    }
    try {
      return JSON.parse(trimmed);
    } catch {
      return null;
    }
  }
  if (typeof d === "object" && Object.keys(d).length > 0) {
    return d;
  }
  return null;
}

export function hasValidRevisionTemplatePayload(templateRecord) {
  const body = getRevisionTemplateBodyForSave(templateRecord);
  return (
    body != null &&
    (body.TEMPLATE !== undefined || body.WORKFLOW_DEFINITION !== undefined)
  );
}

/**
 * Writes retrieved revision content to userspace on disk (saveToUserSpace path on server).
 * @param {import('@reduxjs/toolkit').ThunkDispatch} dispatch
 * @param {{ account: string, workflowGroupName: string, templateName: string, templatePath: string, templateApiRecord: object }} args
 */
export function persistRetrievedRevisionToUserSpace(dispatch, args) {
  const { account, workflowGroupName, templateName, templatePath, templateApiRecord } = args;
  const body = getRevisionTemplateBodyForSave(templateApiRecord);
  if (!body) {
    return Promise.reject(new Error("No template data"));
  }
  if (body.TEMPLATE === undefined && body.WORKFLOW_DEFINITION === undefined) {
    return Promise.reject(new Error("Invalid template shape"));
  }

  const pathForType = templateApiRecord.path || templatePath;
  const endpoint = getPersistEndpointKeyForPath(pathForType);
  const comment = "";
  const save_to_server = "false";

  if (endpoint === "saveInboundTemplate") {
    return dispatch(
      api.endpoints.saveInboundTemplate.initiate({
        account,
        workflowGroupName,
        templateName,
        comment,
        data: body,
        save_to_server,
      })
    ).unwrap();
  }
  if (endpoint === "saveOutboundTemplate") {
    return dispatch(
      api.endpoints.saveOutboundTemplate.initiate({
        account,
        workflowGroupName,
        templateName,
        comment,
        data: body,
        save_to_server,
      })
    ).unwrap();
  }
  return dispatch(
    api.endpoints.saveWorkflowTemplate.initiate({
      account,
      workflowGroupName,
      workflowName: templateName,
      data: body,
      save_to_server,
    })
  ).unwrap();
}